import React from "react";
import {
  Award,
  LayoutDashboard,
  LogIn,
  LogOut,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import Footer from "components/Footer/Footer";
import { signOut } from "../lib/supabase";

export default function PageShell({
  children,
  title,
  eyebrow,
  description,
  actions,
  showSignOut = true,
}) {
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/mentorship", { replace: true });
  }

  return (
    <div className="mentorship-page">
      <div className="mentorship-container">
        {/* Page header row: title left, nav + actions right */}
        <div className="mentorship-page-header">
          <div className="mentorship-page-header-left">
            {eyebrow ? (
              <p className="mentorship-eyebrow">{eyebrow}</p>
            ) : null}
            <h1 className="mentorship-title">{title}</h1>
            {description ? (
              <p style={{ marginTop: "6px", fontSize: "14px", color: "#64748b" }}>
                {description}
              </p>
            ) : null}
          </div>

          <div className="mentorship-page-header-right">
            {/* Extra actions (e.g. view toggles, refresh) */}
            {actions ? (
              <div className="mentorship-extra-actions">{actions}</div>
            ) : null}

            {/* Sign out / Login */}
            {showSignOut ? (
              <button
                className="mentorship-auth-btn"
                onClick={handleSignOut}
                type="button"
              >
                <LogOut style={{ width: "15px", height: "15px" }} />
                Sign out
              </button>
            ) : (
              <button
                className="mentorship-auth-btn"
                onClick={() => navigate("/mentorship")}
                type="button"
              >
                <LogIn style={{ width: "15px", height: "15px" }} />
                Login
              </button>
            )}
          </div>
        </div>

        {/* Page body */}
        <div className="mentorship-page-body">
          {children}
        </div>
      </div>

      <Footer />
    </div>
  );
}
